// Profile email reveal: the profile box renders a contact BUTTON with no address
// in the initial HTML (keeps e-mails out of the page source, deterring basic
// scrapers). Clicking it fetches the profile's `.ajax` view (`_ajax/profile_full`
// → a `mailto:` link) and swaps it into the wrapper named by `data-selector`, in
// place of the button. Delegated at the document so it survives ASwap page swaps
// without re-binding. Mirrors `shared/modvideo.ts`.
export const initEmailReveal = () => {
  document.addEventListener('click', onDocClick);
};

const onDocClick = (e: MouseEvent) => {
  const trigger = (e.target as Element).closest<HTMLElement>('.profile-email-trigger');
  if (!trigger) return;

  const url = trigger.dataset.url;
  const selector = trigger.dataset.selector;
  const wrapper = selector ? document.querySelector(selector) : null;

  if (!url || !wrapper || trigger.classList.contains('loading')) return;

  trigger.classList.add('loading');

  fetch(url)
    .then((r) => r.text())
    .then((html) => {
      wrapper.innerHTML = html;
      revealEmail(wrapper);
    })
    .catch(() => {
      trigger.classList.remove('loading');
    });
};

// De-obfuscate the address the `.ajax` fragment delivers base64-encoded (kept out
// of the response as plaintext to deter naive scrapers) and wire up the link.
const revealEmail = (wrapper: Element) => {
  const link = wrapper.querySelector<HTMLAnchorElement>('.profile-email-link[data-email]');
  if (!link) return;

  let email = '';
  try {
    email = atob(link.dataset.email || '');
  } catch {
    return;
  }
  if (!email) return;

  link.href = `mailto:${email}`;
  const label = link.querySelector('span');
  if (label) label.textContent = email;
  link.removeAttribute('data-email');
};
